import Vue, { defineAsyncComponent } from 'vue'
import { ModalPlugin, ToastPlugin, VBModal } from 'bootstrap-vue'
import { createPinia, PiniaVuePlugin } from 'pinia'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'

import '@core/utils/blobPollyfill'

import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/libs/i18n'

// Global Components
import './global-components'
// 3rd party plugins
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
// Custom
import './icons'

import disableDevtool from 'disable-devtool'
import VueEasytable from 'vue-easytable'
import VueFileAgent from 'vue-file-agent'
// import RouterTab and styles
import RouterTab from 'vue-router-tab'
import Vue2Filters from 'vue2-filters'

import 'vue-router-tab/dist/lib/vue-router-tab.css'

import { Cascader, CascaderPanel, Scrollbar, Tree } from 'element-ui'
import { vMaska } from 'maska'
import VueCookies from 'vue-cookies'
import VSelect from 'vue-select'
import toastmixin from '@core/mixins/toast'

import '@validations'
import './styles'

import('vue-tour').then(Plugin => {
    const PluginObject = Plugin.default ? Plugin.default : Plugin
    Vue.use(PluginObject)
})

Vue.directive('maska', vMaska)

// Formatos en renderizado (https://www.npmjs.com/package/vue2-filters#currency)
Vue.use(Vue2Filters)

// Subir Archivo (https://safrazik.com/vue-file-agent/)
Vue.use(VueFileAgent)

// SVG (https://www.npmjs.com/package/vue-inline-svg)
Vue.component(
    'inline-svg',
    defineAsyncComponent(() => import('vue-inline-svg'))
)

// https://element.eleme.io/#/es/component/quickstart
Vue.use(Cascader)
Vue.use(CascaderPanel)
Vue.use(Tree)
Vue.use(Scrollbar)

// https://bhuh12.github.io/vue-router-tab/
Vue.use(RouterTab)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use('b-modal', VBModal)

// Composition API
// Vue.use(VueCompositionAPI)

// easytable documentation (https://happy-coding-clans.github.io/vue-easytable/#/en/doc/start)
Vue.use(VueEasytable)

// For vue-like cookies support
Vue.use(VueCookies)

Vue.mixin(toastmixin)

Vue.component('v-select', VSelect)

Vue.config.productionTip = false
Vue.use(PiniaVuePlugin)
const pinia = createPinia()
pinia.use(piniaPluginPersistedState)

// No mostrar herramientas de vue en produccion
if (import.meta.env.PROD) {
    disableDevtool({
        md5: import.meta.env.VITE_MD5_DEVTOOLS,
        tkName: import.meta.env.VITE_MD5_TOKEN_NAME,
    })
    Vue.config.devtools = false
    Vue.config.debug = false
    Vue.config.silent = true
}

Vue.config.keyCodes = {
    tab: 9,
}

const app = new Vue({
    router,
    store,
    i18n,
    pinia,
    render: h => h(App),
})

app.$mount('#app')
